export const payersHeaders = [
  { key: 'stakeholderName', label: 'Pagador' },
  { key: 'stakeholderIdentifier', label: 'Rut' },
  { key: 'documentsCount', label: 'Documentos' },
  { key: 'totalAmount', label: 'Monto', type: 'money' },
  {
    key: 'concentrationLimit',
    label: 'Límite de Concentración',
    type: 'money',
  },
  {
    key: 'amountArrear',
    label: 'Mora',
    type: 'money',
  },
  {
    key: 'conciliatedByBusinessAmount',
    label: 'Recaudado cliente',
    type: 'money',
  },
  {
    key: 'conciliatedByStakeholderAmount',
    label: 'Recaudado pagador',
    type: 'money',
  },
  {
    key: 'conciliatedTotalAmount',
    label: 'Recaudado total',
    type: 'money',
  },
];
export const documentssHeaders = [
  {
    key: 'folio',
    label: 'Folio',
  },
  {
    key: 'code',
    label: 'Código Doc.',
  },
  {
    key: 'stakeholderName',
    label: 'Pagador',
  },
  { key: 'stakeholderIdentifier', label: 'Rut pagador' },
  { key: 'stakeholderSegment', label: 'Segmento pagador' },

  {
    key: 'paymentDate',
    label: 'Fecha pago',
    type: 'date',
  },
  {
    key: 'confirmStatus',
    label: 'Verificación',
    type: 'verificationStatus',
    canNull: true,
  },
  {
    key: 'confirmedBy',
    label: 'Verificado por',
    canNull: true,
  },
  {
    key: 'confirmType',
    label: 'Tipo Verificación',
    canNull: true,
  },
  {
    key: 'confirmMessage',
    label: 'Comentario',
  },
  {
    key: 'cancelDate',
    label: 'Reclamos?',
    type: 'cession-lights-false',
    canNull: true,
  },
  {
    key: 'invoiceAmount',
    label: 'Monto original',
    type: 'money',
  },
  {
    key: 'amountDocument',
    label: 'Monto',
    type: 'money',
  },
  {
    key: 'amountFinanced',
    label: 'Monto financiado',
    type: 'money',
  },

  {
    key: 'costRate',
    label: 'Costo tasa',
    type: 'money',
  },
  {
    key: 'amountToDeposit',
    label: 'Montos a depositar',
    type: 'money',
  },
];

export const appliedHeaders = [
  { key: 'folio', label: 'Folio' },
  { key: 'requestType', label: 'Tipo' },
  { key: 'requestId', label: 'Solicitud' },
  {
    key: 'stakeholderName',
    label: 'Pagador',
  },
  {
    key: 'amount',
    label: 'Monto',
    type: 'money',
  },
  {
    key: 'amountConciliated',
    label: 'Monto aplicado',
    type: 'money',
  },
];
